import { Outlet, useNavigate, useNavigation } from "react-router";
import PageTitle from "../../global/components/PageTitle";
import {
  TabList,
  Tab,
  SelectTabData,
  SelectTabEvent,
  TabValue,
  shorthands,
  makeStyles,
  useId,
  Toaster,
  useToastController,
} from "@fluentui/react-components";

import {
  BookClock24Filled,
  BookClock24Regular,
  BookDatabase24Filled,
  BookDatabase24Regular,
  ChartMultiple24Filled,
  ChartMultiple24Regular,
  bundleIcon,
} from "@fluentui/react-icons";
import React from "react";
import ChangesLoadedToast from "./Toasts/ChangesLoadedToast";

const PendingIcon = bundleIcon(BookClock24Filled, BookClock24Regular);
const AllChangesIcon = bundleIcon(BookDatabase24Filled, BookDatabase24Regular);
const AnalyticsChanges = bundleIcon(
  ChartMultiple24Filled,
  ChartMultiple24Regular
);

const useStyles = makeStyles({
  root: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    rowGap: "20px",
  },
  panels: {
    ...shorthands.padding(0, "10px"),
    "& th": {
      textAlign: "left",
      ...shorthands.padding(0, "30px", 0, 0),
    },
  },
});

const AdminLayout = () => {
  const navigate = useNavigate();

  const styles = useStyles();

  const [selectedValue, setSelectedValue] =
    React.useState<TabValue>("conditions");

  const onTabSelect = (event: SelectTabEvent, data: SelectTabData) => {
    setSelectedValue(data.value);
  };

  const toasterId = useId("admin-toaster");
  const { dispatchToast } = useToastController(toasterId);

  const notify = () =>
    dispatchToast(<ChangesLoadedToast />, { intent: "success" });

  return (
    <>
      <PageTitle title="Verwaltung" />
      <Toaster id={toasterId} />
      <div className={styles.root}>
        <TabList selectedValue={selectedValue} onTabSelect={onTabSelect}>
          <Tab
            id="pending"
            icon={<PendingIcon />}
            value="pending"
            onClick={() => navigate("/verwaltung")}
          >
            Pending
          </Tab>
          <Tab
            id="allChanges"
            icon={<AllChangesIcon />}
            value="allChanges"
            onClick={() => navigate("/verwaltung/all-changes")}
          >
            Alle Änderungen
          </Tab>
          <Tab
            id="analytics"
            icon={<AnalyticsChanges />}
            value="analytics"
            onClick={() => navigate("/verwaltung/analytics")}
          >
            Analytics
          </Tab>
        </TabList>
      </div>
      <Outlet />
    </>
  );
};

export default AdminLayout;
